import React from 'react'
import ReactSelect, { MultiValue, Props as ReactSelectProps } from 'react-select'
import rawStyles from './displays__notifications.jcss'
import translate from 'core/translate'

const styles = (rawStyles as unknown) as Record<string, string>

export interface NotificationEmailOption {
    id?: number
    label: string
    value: string
}

interface IMySelectProps
    extends Omit<ReactSelectProps<NotificationEmailOption, true>, 'isMulti' | 'options' | 'value' | 'onChange'> {
    allowSelectAll?: boolean
    value?: MultiValue<NotificationEmailOption> | null
    onChange: (selected: MultiValue<NotificationEmailOption>) => void
    options: NotificationEmailOption[]
    allOption?: NotificationEmailOption
    separator?: boolean
}

const getAllOption = (): NotificationEmailOption => ({
    label: translate('selectAll'),
    value: '*',
})

export const MySelect = ({
    allowSelectAll = false,
    allOption = getAllOption(),
    onChange,
    options,
    separator: _separator,
    value,
    ...selectProps
}: IMySelectProps) => {
    if (allowSelectAll) {
        return (
            <ReactSelect<NotificationEmailOption, true>
                classNamePrefix={styles.customSelect}
                {...selectProps}
                isMulti
                value={value}
                options={[allOption, ...options]}
                onChange={(selected) => {
                    if (selected.length > 0 && selected[selected.length - 1].value === allOption.value) {
                        onChange(options)
                        return
                    }

                    onChange(selected)
                }}
            />
        )
    }

    return (
        <ReactSelect<NotificationEmailOption, true>
            {...selectProps}
            isMulti
            value={value}
            options={options}
            onChange={onChange}
        />
    )
}
